class ArgumentError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "ValidationError"
  }
}

class MVaultError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "MVaultMembershipError"
  }
}

class TVaultError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "TVaultError"
  }
}

class MembershipNotFoundError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "MembershipNotFoundError"
  }
}

class MembershipNotSelfCancellableError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "MembershipNotSelfCancellableError"
  }
}

class MembershipNotConvertibleError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "MembershipNotConvertibleError"
  }
}

class MissingRefreshTokenError extends Error {
  constructor(message: string) {
    super(message)
    this.name = "MissingRefreshTokenError"
  }
}

class StationDataCacheEmptyError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'StationDataCacheEmptyError'
  }
}

class DuplicateSVPHostError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'DuplicateSVPHostError'
  }
}

class NoAuthenticatedSessionError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'NoAuthenticatedSessionError'
  }
}

class ClientSessionInvalid extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ClientSessionInvalid'
  }
}

class SerializedAutoCompleteDatabaseError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'SerializedAutoCompleteDatabaseError'
  }
}

class ServerError extends Error {
  statusCode: number
  constructor(message: string, statusCode: number) {
    super(message)
    this.name = 'ServerError'
    this.statusCode = statusCode
  }
}

class GetProfileServerError extends ServerError {
  constructor(message: string, statusCode: number) {
    super(message, statusCode)
    this.name = 'GetProfileServerError'
  }
}

class GetFavoriteStationsServerError extends ServerError {
  constructor(message: string, statusCode: number) {
    super(message, statusCode)
    this.name = 'GetFavoriteStationsServerError'
  }
}

class GetViewingHistoryServerError extends ServerError {
  constructor(message: string, statusCode: number) {
    super(message, statusCode)
    this.name = 'GetViewingHistoryServerError'
  }
}

class GraphQLFetchError extends ServerError {
  constructor(message: string, statusCode: number) {
    super(message, statusCode)
    this.name = 'GraphQLFetchError'
  }
}

class TokenRefreshInProgressError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'TokenRefreshInProgressError'
  }
}

class RefreshTokenRejectedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'RefreshTokenRejectedError'
  }
}

class NoUIDError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'NoUIDError'
  }
}

export {
  ArgumentError,
  MVaultError,
  TVaultError,
  MembershipNotFoundError,
  MembershipNotSelfCancellableError,
  MembershipNotConvertibleError,
  MissingRefreshTokenError,
  TokenRefreshInProgressError,
  RefreshTokenRejectedError,
  StationDataCacheEmptyError,
  DuplicateSVPHostError,
  NoAuthenticatedSessionError,
  ClientSessionInvalid,
  SerializedAutoCompleteDatabaseError,
  ServerError,
  GetProfileServerError,
  GetFavoriteStationsServerError,
  GetViewingHistoryServerError,
  GraphQLFetchError,
  NoUIDError
}
